import { Component, OnInit, ViewChild } from '@angular/core';

import { TeemappTableComponent } from '@teem/shared/index';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';

import { HistoryTableSchema } from '@teem/billing-module/classes/history-table-schema';
import { InvoiceTransactionHistory } from '@teem/billing-module/classes/invoice-transaction-history';
import { BillingService } from '@teem/app/core/services/billing.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { Invoice } from '@teem/models/invoice';
import { ViewBillingSubscriptionComponent } from '@teem/billing-module/components/view-billing-subscription/view-billing-subscription.component';
import { MixpanelService } from '@teem/services/mixpanel.service';


import { TeemappService } from '@teem/services/teemapp.service';
import { UserService } from '@teem/services/user.service';

@Component({
	selector: 'app-billing',
	templateUrl: './billing.component.html',
	styleUrls: ['./billing.component.scss'],
	providers: [UserCurrencyPipe]
})
export class BillingComponent implements OnInit {
	activeTab: string = 'subscription-history';
	@ViewChild('historyTableRef') historyTableRef: TeemappTableComponent;
	historyTable: HistoryTableSchema = new HistoryTableSchema(this);

	@ViewChild('invoiceTransactionHistoryTableRef') invoiceTransactionHistoryTableRef: TeemappTableComponent;
	invoiceTransactionHistoryTable: InvoiceTransactionHistory = new InvoiceTransactionHistory(this);

	invoice_date: any;
	activeInvoice: any;
	userInfo: any = {};
	experimentInfo: any;
	plans: any;
	subscription: any;


	constructor(private billingService: BillingService,
		private modalService: NgbModal,
		private loaderService: LoaderService,
		private currencyPipe: UserCurrencyPipe,
		private teemappService: TeemappService,
		private userService: UserService,
		private mixpanelService: MixpanelService,

	) { }

	ngOnInit(): void {
		this.fetchUserInfo();
		this.fetchPlans();

	}
	fetchUserInfo() {
		this.loaderService.startLoading();
		this.userService.getUser().subscribe(data => {
			this.userInfo = data;
			this.subscription = this.userInfo ? this.userInfo.subscription : null;
			this.experimentInfo = this.userInfo?.billing_experimente_data?.is_experiment == 1 ? true : false;
			let userProperties = this.mixpanelService.getUserProperties(this.userInfo);
			let trackProperties = this.mixpanelService.getTrackProperties(this.userInfo);

			let combinedProperties = {
				...userProperties,
				...trackProperties
			};
			this.mixpanelService.setUserProperties(userProperties);
			if(this.experimentInfo) {
				// Mixpanel event sub_page_empty_view
				this.mixpanelService.track('sub_page_empty_view', combinedProperties);
			} else {
				// Mixpanel event sub_page_view
				this.mixpanelService.track('sub_page_view', combinedProperties);
			}
			if (this.userInfo?.billing_experimente_data?.name) {
				this.mixpanelService.unionUserProperties({ 'experiments': this.userInfo.billing_experimente_data.name })
			}
			this.loaderService.stopLoading();
		}, err => {
			this.loaderService.stopLoading();
		});
	}

	// experimentUserView() {
	// 	let status = false;
	// 	// if(this.userInfo.billing_experimente_data.is_experiment == 1) {
	// 	// 	status = true;
	// 	// }
	// 	return status;
	// }

	isEmpty(obj: any): boolean {
		return obj == null || Object.keys(obj).length === 0;
	}

	onPlanChange() {
		window.location.reload()
	}


	fetchPlans() {
		this.teemappService.getPlans().subscribe((data: any) => {
			this.plans = data;
		});
	}

	switchTab(tab: string) {
		this.activeTab = tab;
	}


	invoiceActions(action, invoice: any) {
		switch (action) {
			case INVOICE_ACTIONS.VIEW:
				this.viewInvoice([invoice.uuid])
				break;
			case INVOICE_ACTIONS.VIEW_INVOICE_TRANSACTION:
				this.viewInvoiceTransaction([invoice.uuid])
				break;
		}
	}

	viewInvoice(selectedInvoices: Array<string>) {

		this.loaderService.startLoading();
		this.billingService.billingSubscriptionTransaction(selectedInvoices[0]).subscribe((invoice: Invoice) => {
			this.activeInvoice = invoice;
			// this.activeTab = "view-invoice";
			// this.activeTab = "view-billing-subscription";
			this.viewInvoiceModalCall(this.activeInvoice);

			this.loaderService.stopLoading();
		}, err => {
			Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			this.loaderService.stopLoading();
		})

	}

	viewInvoiceModalCall(activeInvoice) {

		const modalRef = this.modalService.open(ViewBillingSubscriptionComponent);
		modalRef.componentInstance.invoiceDetail = activeInvoice;
		modalRef.result.then(result => {
		}, fallbackResult => {

		})
	}

	viewInvoiceTransaction(selectedInvoices: Array<string>) {

		this.loaderService.startLoading();
		this.billingService.billingInvoiceTransactionHistory(selectedInvoices[0]).subscribe((invoice: Invoice) => {
			this.activeInvoice = invoice;
			// this.activeTab = "view-invoice";
			// this.activeTab = "view-billing-Transaction";
			this.viewInvoiceModalCall(this.activeInvoice);
			this.loaderService.stopLoading();
		}, err => {
			Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			this.loaderService.stopLoading();
		})

	}

   onLoadBillingHistory(data: any) {
    setTimeout(() => {
      // @ts-ignore
      $('[nice-select]').niceSelect('update');
    }, 10);
  }
}
